import { makeStyles } from "../../../providers/makeStyles";
import { Typography } from "@mui/material";

import { JerseyAvatar } from "../../heat/JerseyAvatar";
import { T } from "../../../util/t";

export const useAthleteBoxStyles = makeStyles(theme => ({
    box: {
        display: "flex",
        alignItems: "center",
        padding: theme.spacing(1, 2),
        border: `2px solid ${theme.palette.border.main}`,
        borderRadius: theme.spacing(1),
        marginTop: theme.spacing(0.5),
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    position: {
        marginLeft: "auto",
        textAlign: "center"
    }
}));
export const ScannedEntryItem = ({ entry, isTeams, showSeed }) => {
    const classes = useAthleteBoxStyles();
    const athlete = entry.athlete;

    return (
        <div className={classes.box}>
            <JerseyAvatar className={classes.avatar} src={athlete.image} alt={athlete.name}/>
            <section>
                <Typography variant="button3" component="p">{athlete.name}</Typography>
                {isTeams
                    ? <Typography component="p" color="textSecondary">{entry.teamMembers.map(m => m.athlete.name).join(", ")}</Typography>
                    : entry.teamName && <Typography component="p" color="textSecondary">{entry.teamName}</Typography>
                }
            </section>
            {showSeed &&
            <aside className={classes.position}>
                <Typography variant="caption" component="p"><T>Position</T></Typography>
                <Typography variant="h3" component="p">{entry.seed || "-"}</Typography>
            </aside>}
        </div>
    );
};
